import React, { FC } from "react";
import clsx from "clsx";

import Icon from "./Icon";
import styles from "./EvaluationButton.module.scss";

type Props = {
  type: "good" | "bad";
  size?: string;
  color: string;
  isEvaluated: boolean;
  calling: boolean;
  onClick: () => void;
};

const EvaluationButton: FC<Props> = ({
  type,
  size = "16",
  color,
  isEvaluated,
  calling,
  onClick,
}) => {
  return (
    <button
      className={clsx(styles.button, type === "bad" && styles.isBad)}
      onClick={onClick}
      disabled={calling}
    >
      <Icon size={size} color={color} isEvaluated={isEvaluated} />
    </button>
  );
};

export default EvaluationButton;
